import { rootLinks } from '../app/links';

const base = `${rootLinks.inner()}/chat`;

export const chatLinks = {
  root: () => `${base}`,
  chatMessages: (chatId: string) => `${base}/${chatId}`,
};
